<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div :class="height" class="p-0 transition duration-500 ease-in-out rounded-lg">
        <div class="duration-500 ease-in-out space-x-3 px-0 py-0 bg-gray-800 sm:bg-transparent" v-if="avatar || title">
            <div v-if="avatar || $slots.avatar" class="shrink-0">
                <slot name="avatar">
                    <img class="h-10 w-10 rounded-full" :src="avatar" alt="" />
                </slot>
            </div>
            <div :class="[showTitle ? 'grid-cols-3' : 'grid-cols-1']" class="min-w-0 grid md:grid-cols-3 items-center">
                <slot name="title">
                    <slot name="filter"></slot>
                    <p :class="{ 'text-center': centerText }" class="text-1xl md:text-2xl font-semibold transition duration-500 ease-in-out text-white sm:text-gray-600 sm:dark:text-white col-span-1 md:col-span-1 col-start" v-if="showTitle">
                        {{ title }}
                    </p>
                    <slot name="filter2"></slot>
                    <!-- <a href="#" @click="showForm = true" :class="{ 'md:col-start-4 md:col-end-4': !centerText }" class="text-right flex justify-end items-center text-white" v-if="!hideHow">
                        <span>How to Play</span>
                        <QuestionMarkCircleIcon class="text-white w-4 ml-2" />
                    </a> -->
                </slot>
            </div>
        </div>
        <hr v-show="divide" class="sm:mt-4 border-gray-300 dark:border-gray-600">
        <div :class="maxHeight" class="h-full overflow-y-auto overflow-x-hidden">
            <slot></slot>
        </div>
    </div>

    <tw-modal :show="showForm" width="1250" @close="showForm = false">
        <div class="col-span-2 md:col-span-1 p-3 sm:p-6 md:p-12 ">
            <div class="flex flex-col mt-4 dark:text-gray-800">
                <h1 class="text-white text-2xl text-center mb-2">How it Works</h1>

                <div class="flex mb-4" v-for="(item, key) in items">
                    <div class="flex shrink mr-4">
                        <span class="border border-racing-stars-yellow rounded-full flex items-center justify-center text-center text-white w-10 h-10">{{ key + 1 }}</span>
                    </div>
                    <div class="text-white">
                        <h2 class="text-2xl font-bold">{{ item.title }}</h2>
                        <span class="" v-html="item.content"></span>
                        <vue-player-video v-if="key === 4" class="z-0 mt-4 md:w-1/2 " :src="asset('media/how-it-works.mp4')" colors="#fceb0d" />
                    </div>
                </div>
            </div>
        </div>
    </tw-modal>

</template>
<script>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import VuePlayerVideo from 'vue3-player-video'
import { CodeIcon, DotsVerticalIcon, FlagIcon, StarIcon, QuestionMarkCircleIcon } from '@heroicons/vue/solid'
import {ref} from "vue";

export default {
    props: {
        title: [String, Object],
        showTitle: {
            type: Boolean,
            default: true,
        },
        hideHow: {
            type: Boolean,
            default: false,
        },
        avatar: String,
        actions: Array,
        divide: Boolean,
        height: String,
        maxHeight: String,
        centerText: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        CodeIcon,
        DotsVerticalIcon,
        FlagIcon,
        StarIcon,
        QuestionMarkCircleIcon,
        VuePlayerVideo
    },
    setup(props) {
        const showForm = ref(false)

        const items = [
            {
                title: "Pick a Meeting",
                content: "Pick a meeting for today's or tomorrows racing.",
            },
            {
                title: 'Pick One Horse from Each Race',
                content: 'Select one horse from each of the available racing events.',
            },
            {
                title: 'Confirm Your Selections',
                content: 'Once you have picked your horses, sit back, relax and enjoy the racing. You can change your selections at any point up to 2 minutes before the start of the race.',
            },
            {
                title: 'Points System',
                content: 'Points are awarded for any qualifying horses and their ‘sp’ (starting price) is multiplied according to their finishing position. This gives everyone a level playing field, experts and novices alike! The unique system allows you to pick the outsiders! The higher the odds the more points! The more points the more wins!',
            },
            {
                title: 'Number of Runners & Positions Paid',
                content:
                    '<style type="text/css">\n' +
                    '.tg  {border-collapse:collapse;border-spacing:0;}\n' +
                    '.tg td{border-color:white;border-style:solid;border-width:1px;' +
                    '  overflow:hidden;padding:10px 5px;word-break:normal;}\n' +
                    '.tg th{border-color:black;border-style:solid;border-width:1px;' +
                    '  font-weight:normal;overflow:hidden;padding:10px 5px;word-break:normal;}\n' +
                    '.tg .tg-23yt{border-color:white;text-align:center;vertical-align:top}\n' +
                    '.tg .tg-wp8o{border-color:white;text-align:center;vertical-align:top}\n' +
                    '</style>\n' +
                    '<table class="tg">\n' +
                    '<thead>\n' +
                    '  <tr>\n' +
                    '    <th class="tg-wp8o">Runners/' +
                    '<br/>Position</th>\n' +
                    '    <th class="tg-wp8o">1-4</th>\n' +
                    '    <th class="tg-wp8o">5-7</th>\n' +
                    '    <th class="tg-wp8o">8-12</th>\n' +
                    '    <th class="tg-wp8o">13+</th>\n' +
                    '  </tr>\n' +
                    '</thead>\n' +
                    '<tbody>\n' +
                    '  <tr>\n' +
                    '    <td class="tg-23yt">1st</td>\n' +
                    '    <td class="tg-23yt">x5</td>\n' +
                    '    <td class="tg-23yt">x5</td>\n' +
                    '    <td class="tg-23yt">x5</td>\n' +
                    '    <td class="tg-23yt">x5</td>\n' +
                    '  </tr>\n' +
                    '  <tr>\n' +
                    '    <td class="tg-wp8o">2nd<br></td>\n' +
                    '    <td class="tg-wp8o"></td>\n' +
                    '    <td class="tg-wp8o">x3</td>\n' +
                    '    <td class="tg-wp8o">x3</td>\n' +
                    '    <td class="tg-wp8o">x3</td>\n' +
                    '  </tr>\n' +
                    '  <tr>\n' +
                    '    <td class="tg-23yt">3rd</td>\n' +
                    '    <td class="tg-23yt"></td>\n' +
                    '    <td class="tg-23yt"></td>\n' +
                    '    <td class="tg-23yt">x2</td>\n' +
                    '    <td class="tg-23yt">x2</td>\n' +
                    '  </tr>\n' +
                    '  <tr>\n' +
                    '    <td class="tg-wp8o">4th</td>\n' +
                    '    <td class="tg-wp8o"></td>\n' +
                    '    <td class="tg-wp8o"></td>\n' +
                    '    <td class="tg-wp8o"></td>\n' +
                    '    <td class="tg-wp8o">x1</td>\n' +
                    '  </tr>\n' +
                    '</tbody>\n' +
                    '</table>'+
                    'Watch Tom Stanley explain:',
            },
            {
                title: 'Winnings',
                content: 'Each meeting has its own daily jackpot £££. The winner is the person(s) with the highest points scored for that meeting. (pot split if 2 or more people have the same number of points). Winnings paid as cash into your account shortly after the event has finished.',
            }
        ]
        return {
            showForm,
            items,
        }
    }
}

</script>
